export const countFilterKeys = searchFilters => {
  if (!searchFilters) return 0;
  const trimmed = searchFilters.startsWith('&')
    ? searchFilters.slice(1)
    : searchFilters;
  if (!trimmed) return 0;
  const params = new URLSearchParams(trimmed);
  const uniqueKeys = new Set();
  for (const [key, value] of params.entries()) {
    if (!value) continue;
    const cleanKey = key.replace(/\[\]$/, '');
    if (cleanKey === 'search_type') continue;
    uniqueKeys.add(cleanKey);
  }
  return uniqueKeys.size;
};

export const truncate = (value, max = 24) => {
  if (!value) return '';
  return value.length > max ? `${value.slice(0, max - 1)}…` : value;
};
